/* THIS IS A GENERATED FILE, DO NOT EDIT MANUALLY! */
/* eslint-disable -- This is a generated file */
// import utils
import useSWR from "swr";
import client from "../../feature-discovery/utils/axios.client.js";
export const useGet = (requestConfig = {}, { shouldFetch, ...swrConfig } = {}) => {
    const _shouldFetch = shouldFetch ?? true;
    return useSWR(() => (_shouldFetch ? [requestConfig.url, requestConfig.params] : null), () => client(requestConfig), swrConfig);
};
export default useGet;
